"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APTAMember = void 0;
const index_1 = require("../index");
const IdentityInfo_1 = __importDefault(require("../IdentityInfo"));
class APTAMember {
    constructor(data, desc) {
        this.sectionTitleFunc = (mbt_code) => {
            if (mbt_code) {
                let memberPrefix = mbt_code
                    .trim()
                    .match(/\(([0-9]|[aA-zZ])*\)/g)?.[0];
                if (!memberPrefix)
                    return "Unsorted";
                return mbt_code.substring(memberPrefix.length).trim();
            }
            return "Unsorted";
        };
        this.identityInfo = IdentityInfo_1.default.genFromList(null, data, [
            "OBJECTID",
            "adr_phys_state_ext",
            "CD",
            null,
            "sldl",
            "sldu",
        ]);
        this.address = index_1.parseEsriString(data?.Match_addr);
        this.orgName = index_1.parseEsriString(data?.cst_name_cp);
        this.mbt_code = index_1.parseEsriString(data?.mbt_code);
        this.mbt_reporting_group_ext = index_1.parseEsriString(data?.mbt_reporting_group_ext);
        //this.orgURL= data.cst_url_code_dn
        this.org_ogt_code = index_1.parseEsriString(data?.org_ogt_code);
        if (desc) {
            this.orgDescription = index_1.parseEsriString(data?.org_description_ext);
        }
        else {
            this.orgDescription = null;
        }
        this.sectionTitle = this.sectionTitleFunc(data?.mbt_code);
        this.geometry = data.geometry;
    }
}
exports.APTAMember = APTAMember;
